import React from "react";
import { Row, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { gaEvent } from "analytics/analytics";
import * as GA from "constants/analytics";

export default function BreadcrumbComponent({ type, collectionId }) {
  return (
    <>
      <Row style={{top:0}}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/" onClick={() => {
              gaEvent(GA.EVENT.CLICK, GA.CATEGORY.RETURN, GA.DESCRIPTION.RETURN_TO_HOME);
            }}> Home</Link>
          </Breadcrumb.Item>
           
          <Breadcrumb.Item>
            {type ? "" : (
              <Link to="/create-collection" onClick={() => {
                gaEvent(GA.EVENT.CLICK, GA.CATEGORY.RETURN, GA.DESCRIPTION.RETURN_TO_CREATE_CATALOGUE);
              }}>Create Catalogue</Link>
            )}
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/select-products/${collectionId}`} onClick={() => {
              gaEvent(GA.EVENT.CLICK, GA.CATEGORY.RETURN, GA.DESCRIPTION.RETURN_TO_PRODUCT_SELECTION);
            }}>
              {" "}
              Product selection
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Edit Details</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    </>
  );
}
